export default "__VITE_ASSET__ChISl658__"